// FDI (11-48) -> quadrant-local digit (1-8), as printed on the Billing PDF.
export const fdiToPalmer = (fdiNum) => parseInt(fdiNum) % 10;

// Right-hand quadrants (S1 upper right, S3 lower right) read 8 -> 1 toward the midline.
// `separator` defaults to ', ' so the job cards, daily report and sales reports that also
// call this are unaffected; the Billing statement passes a plain space because its Tooth
// column is narrow and a full quadrant has to stay on one line.
export const palmerDesc = (section, separator = ', ') =>
    Array.isArray(section) && section.length > 0
        ? section.map(fdiToPalmer).sort((a, b) => b - a).join(separator)
        : null;

// Left-hand quadrants (S2 upper left, S4 lower left) read 1 -> 8 away from the midline.
export const palmerAsc = (section, separator = ', ') =>
    Array.isArray(section) && section.length > 0
        ? section.map(fdiToPalmer).sort((a, b) => a - b).join(separator)
        : null;

// Total selected units across all four quadrants.
export const unitCount = (sections) =>
    ['S1', 'S2', 'S3', 'S4'].reduce(
        (sum, key) => sum + (Array.isArray(sections && sections[key]) ? sections[key].length : 0), 0);
